<template>
  <div class="row letter-bar">
    <div class="col-12 no-wrap scroll justify-around text-center">
      <q-btn
        small
        v-for="letter in availableLetters"
        :key="letter"
        @click="handleLetter(letter)"
        class="self-center"
        :color="selectedLetters[letter] ? 'info' : 'grey-5'"
        :outline="selectedLetters[letter]"
        :flat="!selectedLetters[letter]"
      >
        {{ letter }}
      </q-btn>
    </div>
  </div>
</template>
<script>
const allLetters = 'abcdefghijklmnopqrstuvwxyz'.split('')

export default {
  name: 'AzBar',
  props: {
    resource: String
  },
  data () {
    return {
      availableLetters: allLetters
    }
  },
  computed: {
    selectedLetters () {
      return this.$store.getters[`${this.resource}/filters`].letters
    }
  },
  methods: {
    handleLetter (letter) {
      let letters = this.selectedLetters
      const undoLetters = {...letters}
      let msg = 'Added'
      const exists = letters[letter]
      if (exists) {
        delete letters[letter]
        msg = 'Removed'
      } else {
        letters[letter] = true
      }
      this.$store.commit(`${this.resource}/SET_FILTER`, {field: 'letters', value: letters})
      this.$q.notify({
        message: `Letter ${letter} ${msg} from results`,
        icon: 'sort_by_alpha',
        actions: [
          {
            label: 'Undo',
            icon: 'undo',
            handler: () => {
              this.$store.commit(`${this.resource}/SET_FILTER`, {field: 'letters', value: undoLetters})
            }
          }
        ]
      })
    }
  }
}
</script>
